import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useStationTimeMoveRange } from '../navigation/useStationTimeMoveRange';

/**
 * Returns whether the current user-defined stream range starts too close to "now"
 * (i.e. its from is after the upper bound — the latest time a from can be used).
 * In that case we do not fetch segments.
 */
export function useIsStreamRangeTooRecent(): boolean {
  const { from, isLoading } = useStreamUserDefinedRange();
  const { to } = useStationTimeMoveRange();

  return !isLoading && from > to;
}
